import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';

require("select2/dist/css/select2.css")
require("select2-bootstrap-theme/dist/select2-bootstrap.css")

import Select2 from "select2"
require("javascripts/select2.customSelectionAdapter.min.js")

export default class extends Controller {
  static targets = [ "select2Custom", "select2Single", "select2SingleAsSearch", "select2Multiple" ]

  connect() {
    if(this.hasSelect2CustomTarget){
      const customSelectionAdapter = $.fn.select2.amd.require("select2/selection/customSelectionAdapter");
      const select2TargetElement = $('.' + this.select2CustomTarget.dataset.classSelect2Target)
      select2TargetElement.select2({
        selectionAdapter: customSelectionAdapter,
        selectionContainer: $('.' + this.select2CustomTarget.dataset.resultSelect2Target)
      })
    }

    const select2CustomElement = $(".select2Custom")
    if (!select2CustomElement.data('select2')) {
      select2CustomElement.each(function() {
        const $el = $(this);
        const closeOnSelect = $el.data('close-on-select') === true;
        $el.select2({
          closeOnSelect: closeOnSelect
        });
      });
      
      select2CustomElement.off('select2:select select2:unselect').on('select2:select select2:unselect', function(e) {
        // Manually trigger the change event for Stimulus
        const event = new Event('change', { bubbles: true });
        e.target.dispatchEvent(event);
        
        // Toggle has-selection class for floating label styling
        const container = $(e.target).closest('.custom-multi-select');
        if (container.length) {
          const hasValues = $(e.target).val() && $(e.target).val().length > 0;
          container.toggleClass('has-selection', hasValues);
        }
      });
      
      // Check initial state for pre-selected values
      select2CustomElement.each(function() {
        const container = $(this).closest('.custom-multi-select');
        if (container.length) {
          const hasValues = $(this).val() && $(this).val().length > 0;
          container.toggleClass('has-selection', hasValues);
        }
      });
    }
  }

  disconnect() {
    try {
      $(this.element).find('select').each(function() {
        if ($(this).data('select2')) {
          $(this).select2('destroy');
        }
      });
    } catch (e) {
      console.error('Error destroying Select2:', e);
    }
  }

  select2MultipleTargetConnected(element) {
    const customSelectionAdapter = $.fn.select2.amd.require("select2/selection/customSelectionAdapter");

    if (this.select2MultipleTarget.data('select2')) this.select2MultipleTarget.select2('destroy');
    $(this.select2MultipleTarget).select2({
      selectionAdapter: customSelectionAdapter,
      selectionContainer: $('.' + this.select2CustomTarget.dataset.resultSelect2Target)
    })
  }

  select2SingleTargetConnected(element) {
    $(element).select2()
    const customSelectionAdapter = $.fn.select2.amd.require("select2/selection/customSelectionAdapter");

    const select2TargetElement = $('.' + this.select2CustomTarget.dataset.classSelect2Target)
    if (select2TargetElement.data('select2')) select2TargetElement.select2('destroy');
    select2TargetElement.select2({
      selectionAdapter: customSelectionAdapter,
      selectionContainer: $('.' + this.select2CustomTarget.dataset.resultSelect2Target)
    })

    $(element).closest('.select2-single-content').children('span.select2.select2-container').not(':first').remove()
  }

  select2SingleAsSearchTargetConnected(element) {
    $(element).select2()
  }

  handleClickDropdownOnProvider() {
    if ($(".select2-results__options>li").length > 3) {
    $(".select2-dropdown--above").css("margin-top", "-60px");
    $(".select2-dropdown--above").css("max-height", "250px");
    $(".select2-results__options").css("max-height", "250px");
    }
    $(".select2-dropdown--above").css("margin-top", "-10px");

  }
}